// extracted by mini-css-extract-plugin
module.exports = {"postSocial":"social-panel-module--post-social--1Phny","postSocialText":"social-panel-module--post-social-text--1p_ck","button":"social-panel-module--button--1yjtV"};